export enum PortalRegistrationStep {
	Info = 1,
	Congratulations = 2,
	Hipaa = 3,
	Photo = 4,
	Insurance = 5,
	License = 6,
	Forms = 7
}
